// dateRangeSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

interface Range {
    startDate: string | null;
    endDate: string | null;
}

interface DateRangeState {
    [moduleKey: string]: Range;
}

// Default date range for reuse
const defaultRange: Range = {
    startDate: dayjs().subtract(2, 'month').startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().subtract(0, 'month').endOf('month').format('YYYY-MM-DD'),
};

// 👇 Two module keys added by default
const initialState: DateRangeState = {
    visitUsers: { ...defaultRange },
    registrations: { ...defaultRange },
};

const dateRangeSlice = createSlice({
    name: 'dateRange',
    initialState,
    reducers: {
        setDateRange: (
            state,
            action: PayloadAction<{ moduleKey: string; startDate: string | null; endDate: string | null }>
        ) => {
            state[action.payload.moduleKey] = {
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
            };
        },
    },
});

export const { setDateRange } = dateRangeSlice.actions;
export default dateRangeSlice.reducer;
